import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=e13a7978&scoped=true"
import script from "./menu-bar.vue?vue&type=script&lang=js"
export * from "./menu-bar.vue?vue&type=script&lang=js"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=e13a7978&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13a7978",
  null
  
)

export default component.exports